import translate from 'angular-translate';

var template = `<div class="form-group">
    <i class="fa fa-question-circle visible-xs form-el-help-btn" ng-hide="$ctrl.noHelp || !$ctrl.formHelp" ng-click="$ctrl.toggleMobileHelp()"></i>
	<label ng-class="$ctrl.classes.label" for="{{$ctrl.for}}">
		{{ $ctrl.label | translate:$ctrl.values | capitalize }}
	</label>
    <div ng-class="$ctrl.classes.input" ng-mouseout="$ctrl.toggleActiveHelp($event)" ng-mouseover="$ctrl.toggleActiveHelp($event)">
        <ng-transclude></ng-transclude>
        <form-error errors="$ctrl.errors"></form-error>
    </div>
    <div class="form-el-help" ng-hide="$ctrl.noHelp || !$ctrl.formHelp" ng-class="$ctrl.classes.help">
        <i class="fa fa-info-circle"></i> <span class="text">{{ $ctrl.formHelp | translate }}</span>
    </div>
</div>`;

export default angular.module('eventix.common.directives.formEl', [translate])
    /**
     * @ngdoc directive
     * @restrict element
     * @name eventix.common.directives:formEl
     * @description
     * A form-group container component. Transcludes a form element with label and help text.
     *
     * @param {String} [label=''] An optional label. If you input a translatable string,
     * it'll be translated
     * @param {Object} [values={}] Optional translation values
     * @param {Object} [errors={}] Optional error object generated by BCErrorable
     * @param {String} [formHelp=''] A help text. Is auto-generated if label matches `/^models/`
     * @param {Boolean} [noHelp=false] Don't display any help text
     * @param {Number} [helpWidth=3] Bootstrap column width of help text on `screens > xs`
     * @param {Number} [labeLWidth=3] Bootstrap column width of label on `screens > xs`
     * @param {Number} [inputWidth=3] Bootstrap column width of form element on `screens > xs`
     */
    .component('formEl', {
        template: template,
        controller: FormElementController,
        transclude: true,
        bindings: {
            label: '@',
            values: '<translateValues',
            errors: '<',
            helpWidth: '<',
            labelWidth: '<',
            inputWidth: '<',
            formHelp: '@'
        }
    }).name;

function FormElementController($element, $translate, $scope, $window, $attrs) {
    const $ctrl = this;
    $ctrl.toggleActiveHelp = toggleActiveHelp;

    $ctrl.$onInit = function() {
        $ctrl.noHelp = $attrs.noHelp !== undefined;
        _.defaults($ctrl, {
            labelWidth: $ctrl.noHelp ? 4 : 3,
            helpWidth: $ctrl.noHelp ? 0 : 3,
            inputWidth: $ctrl.noHelp ? 8 : 6
        });
        setSizeClasses();
    };

    $ctrl.$postLink = function() {
        setName();
        setLabels();
        setPlaceholderAndLabelFor();
        attachEvents();
    };

    $ctrl.$onDestroy = function() {
        detachEvents();
    };

    $ctrl.toggleMobileHelp = function() {
        if(_.includes($ctrl.classes.help, 'hidden-xs'))
            _.pull($ctrl.classes.help, 'hidden', 'hidden-xs');
        else
            $ctrl.classes.help = $ctrl.classes.help.concat(['hidden','hidden-xs']);
        $scope.$applyAsync();
    };

    function toggleActiveHelp(event) {
        if($window.innerWidth < 768)
            return;
        switch(event.type) {
            case 'mouseover':
            case 'focus':
                _.pull($ctrl.classes.help, 'hidden');
                break;
            case 'mouseout':
            case 'blur':
                $ctrl.classes.help.push('hidden');
                break;
            default:
                break;
        }
        $scope.$applyAsync();
    }

    function setLabels() {
        if(!$ctrl.label)
            return;
        let shouldHelp = $ctrl.label.indexOf('models') === 0;
        if (shouldHelp)
            $ctrl.formHelp = 'formHelp.' + $ctrl.label.split('.').slice(1).join('.');
    }

    function setSizeClasses() {
        $ctrl.classes = {
            label: 'control-label hidden-xs col-sm-' + $ctrl.labelWidth,
            input: 'form-el-input col-sm-' + $ctrl.inputWidth,
            help: ['col-sm-' + $ctrl.helpWidth, 'hidden', 'hidden-xs']
        };
    }

    function setName() {
        let el = $element.find('input[type!=checkbox][type!=radio],select,textarea,tx-select').get(0);
        if(!el || (el && el.name && el.name.length))
            return;
        let modelName = el.getAttribute('ng-model');
        if(!modelName || !modelName.length)
            return;
        el.name = modelName.split('.').slice(-1).join('');
    }

    function detachEvents() {
        $element.find('input,textarea').off('blur.formEl focus.formEl input.formEl');
        $element.find('select').off('change.formEl focus.formEl blur.formEl input.formEl');
    }

    function attachEvents() {
        $element.find('input,textarea,tx-select').on('blur.formEl input.formEl', notify);
        $element.find('select').on('change.formEl input.formEl', notify);
        $element.find('input,textarea,select,tx-select').on('focus.formEl blur.formEl', toggleActiveHelp);

        function notify(event) {
            let $input = angular.element(event.target);
            let model = $input.attr('name');
            if (!model || !model.length) return;
            model = model.split('.').slice(-1).join('');
            $scope.$emit('input-blur', model);
        }
    }

    function setPlaceholderAndLabelFor() {
        let el = $element.find('input[type!=checkbox][type!=radio],select,textarea,tx-select').eq(0);
        if (el.length && $ctrl.label) {
            if (_.isEmpty(el.prop('placeholder'))) {
                $translate($ctrl.label, $ctrl.values).then(
                    label => el.prop('placeholder',label),
                    () => el.prop('placeholder', $ctrl.label)
                );
            }
            $ctrl.for = el[0].name;
        }
    }
}
